<template>
  <div>
    <div class="container-fluid">
      <div class="row orta">
        <div class="col-md-8">
          <vx-card>
            <div class="container-fluid">
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-md="12"
                >
                  <h3>{{ $t('addModule') }}</h3>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                  vs-lg="6"
                  vs-sm="6"
                  vs-md="6"
                >
                  <vs-button icon="arrow_back" to="/usermodules">{{ $t('back') }}</vs-button>
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-lg="6"
                  vs-sm="6"
                  vs-md="6"
                >
                  <vs-button
                    icon="save"
                    :disabled="!validateForm"
                    @click="addModuleToUser"
                  >{{ $t('save') }}</vs-button>
                </vs-col>
              </vs-row>

              <div class="row">
                <div class="col-md-6 mt-6">
                  <v-select
                    :placeholder="$t('selectUser')"
                    :name="$t('selectUser')"
                    v-validate="'required'"
                    class="w-full mt-6"
                    :closeOnSelect="true"
                    label="userName"
                    v-model="obj.UserId"
                    :options="users"
                    :reduce="users => users.id"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('selectUser')) }}</span>
                </div>
                <div class="col-md-6 mt-6">
                  <v-select
                    :placeholder="$t('selectModule')"
                    v-validate="'required'"
                    :name="$t('selectModule')"
                    class="w-full mt-6"
                    :closeOnSelect="true"
                    label="moduleName"
                    v-model="obj.ModuleId"
                    :options="modules"
                    :reduce="modules => modules.id"
                    @input="setDescription"
                  />
                   <span class="text-danger text-sm">{{ errors.first($t('selectModule')) }}</span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mt-6">
                  <vs-textarea
                    :label="$t('mark')"
                    height="80px"
                    v-model="obj.Description"
                    class="w-full mt-6"
                  />
                </div>
                <div class="col-md-6 mt-6">
                  <vs-card class="w-full mt-6">
                    <div slot="header">
                      <p>{{$t('moduleContent')}}</p>
                    </div>
                    <div>
                      <p>{{this.Description}}</p>
                    </div>
                  </vs-card>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mt-3">
                  <vs-input
                    v-validate="'required'"
                    :label-placeholder="$t('price')"
                    :name="$t('price')"
                    v-model="obj.Price"
                    class="w-full mt-6"
                    type="number"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('price')) }}</span>
                </div>
                <div class="col-md-6 mt-3">
                  <v-select
                    :placeholder="$t('paymentType')"
                    v-validate="'required'"
                    :name="$t('paymentType')"
                    class="w-full mt-6"
                    :closeOnSelect="true"
                    label="entityName"
                    v-model="obj.PaymentEntityId"
                    :options="paymentTypes"
                    :reduce="paymentTypes => paymentTypes.id"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('paymentType')) }}</span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";
export default {
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.obj.UserId != "" &&
        this.obj.ModuleId != "" &&
        this.obj.Price != "" &&
        this.obj.PaymentEntityId != ""
      );
    }
  },
  data() {
    return {
      users: [],
      modules: [],
      paymentTypes: [],
      res: "",
      Description: "",
      obj: {
        UserId: "",
        ModuleId: "",
        Price: "",
        Description: "",
        PaymentEntityId: ""
      }
    };
  },
  methods: {
    getUsers() {
      let path = "/users/getlist";
      http.get(path).then(response => {
        this.users = response.map(u => {
          return {
            id: u.id,
            userName: u.userName
          };
        });
      });
    },
    getModules() {
      let path = "/Modules/getlist";
      http.get(path).then(response => {
        this.modules = response.map(m => {
          return {
            id: m.id,
            moduleName: m.moduleName
          };
        });
      });
    },
    getPaymentTypes() {
      let path = "/paymenttransactions/getpaymenttypes";
      http
        .get(path, { headers: { "Accept-Language": "tr" } })
        .then(response => {
          this.paymentTypes = response.map(p => {
            return {
              id: p.id,
              entityName: p.entityName
            };
          });
        });
    },
    async addModuleToUser() {
      var data = {
        UserId: this.obj.UserId,
        ModuleId: this.obj.ModuleId,
        Price: parseInt(this.obj.Price),
        Description: this.obj.Description,
        PaymentEntityId: this.obj.PaymentEntityId
      };
      let path = "/PaymentTransactions/makemodulepayment";
      const first = await http.post(path, data).then(response => {
        this.res = response.referenceNumber;
      });

      var paymentPackage = { CallbackData: "satis", ReferenceNumber: this.res };
      let pathPayment = "/PaymentTransactions/bankcallback";
      const second = await http
        .post(pathPayment, paymentPackage)
        .then(response => {
          this.$router.push("/usermodules");
          notify.success(this.$t("saved"), response.message);
        });
    },
    setDescription(id) {
      for (var i = 0; i < this.modules.length; i++) {
        if (id === this.modules[i].id) {
          this.Description = this.modules[i].description;
        }
      }
    }
  },
  created() {
    this.getUsers(), this.getModules(), this.getPaymentTypes();
  }
};
</script>

<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
</style>